import { render, staticRenderFns } from "./loading-indicator.vue?vue&type=template&id=55d60027&"
import script from "./loading-indicator.vue?vue&type=script&lang=js&"
export * from "./loading-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports